import React from 'react'
import { THEME } from 'utils'

const NextVideoOverlay = ({ nextVideo, countdown, paused = false }) => {
  if (!nextVideo) return null
  return (
    <>
      <div className='nextVideo'>
        <div className='nextVideo__content'>
          <div className='row'>
            <div className='col col--title'>
              <p className='nextVideo__countdown'>
                Next video will begin in <span>{countdown} seconds</span> {paused && <i>(Autoplay is paused)</i>}
              </p>
              <h1 className='nextVideo__title'>{nextVideo.title}</h1>
            </div>
            <div className='col col--image'>
              <div className='nextVideo__image'>
                <img src={nextVideo.thumbnail.raw} alt={nextVideo.title} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .nextVideo {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          position: absolute;
          width: 100%;
          height: 0;
          padding-top: 56.25%;
          background: rgba(0, 0, 0, 0.5);
          z-index: 5;
        }
        .nextVideo__content {
          background: rgba(0, 0, 0, 0.5);
          padding: 2rem;
        }
        .nextVideo__countdown {
          color: #cdcdcd;
          font-size: 11px;
          line-height: 1.4;
          font-weight: bold;
          text-transform: uppercase;
          margin-bottom: 0.5rem;
        }
        .nextVideo__countdown span {
          color: ${THEME.COLORS.PRIMARY};
        }
        .nextVideo__title {
          color: #fff;
          font-size: 20px;
          line-height: 1.2;
          font-weight: bold;
        }
        .nextVideo__image {
          margin-left: 0.5rem;
          overflow: hidden;
          position: relative;
        }
        .nextVideo__image img {
          width: 100%;
        }
        @media (min-width: ${THEME.BREAKPOINTS.XS}px) {
          .col--title {
            min-width: 45%;
            flex-basis: 45%;
          }
          .col--image {
            min-width: 55%;
            flex-basis: 55%;
          }
          .nextVideo__countdown {
            font-size: 14px;
          }
          .nextVideo__title {
            font-size: 24px;
          }
        }
      `}</style>
    </>
  )
}

export default NextVideoOverlay
